module.exports = __webpack_public_path__ + "img/img-3.41177c84.png";